import React, {useState} from "react";
import AllocationResidence from "./AllocationResidence";
import {css} from "@emotion/css";
import {
    DialogSize, RaikoAlert, raikoAlertTypes,
    RaikoButtonPrimary, RaikoButtonSecondary, RaikoConfirmDialog,
    RaikoDefaultDialogPage,
    RaikoGridOneColumn, RaikoGridTwoColumn, RaikoLabel, showServerErrorMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {PeriodService} from "../../serverService/periodService/PeriodService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";

const AddResidence = ({periodId, requestId, doRefreshList, reserveId = -1}) => {


    const [openAllocationResidenceDialog, setOpenAllocationResidence] = useState(false)

    function handleOpenAllocationResidenceDialog() {
        setOpenAllocationResidence(true)
    }

    function handleCloseAllocationResidenceDialog() {
        setOpenAllocationResidence(false)
        if (doRefreshList)
            doRefreshList()
    }

    const service = new PeriodService()
    const loading = new LoadingHelper(useLoadingDispatcher())
    const [isRejected, setIsRejected] = useState(false)
    const [newState, setNewState] = useState(false);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false)

    function handleRejectRequest() {
        loading.show()
        service.rejectRequest(requestId)
            .then(response => {
                setIsRejected(true)
                showSuccessMessage("درخواست با موفقیت لغو شد.")
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleOpenConfirmDialog() {
        setOpenConfirmDialog(true)
    }

    function handleCloseConfirmDialog() {
        setOpenConfirmDialog(false)
    }

    return (
        <>
            <RaikoConfirmDialog
                openConfirmDialog={openConfirmDialog}
                cancelAction={handleCloseConfirmDialog}
                pageTitle={"رد درخواست"}
                warningTitle={"آیا از رد درخواست کاربر اطمینان دارید؟"}
                warningDescription={"با رد درخواست امکان تغییر وضعیت درخواست وجود نخواهد داشت"}
                confirmButtonTitle={newState ? "بازگشت" : "رد درخواست"}
                doAction={handleRejectRequest}/>
            <RaikoDefaultDialogPage
                dialogSize={DialogSize.LARGE}
                pageTitle={"انتخاب اقامتگاه"}
                onClose={handleCloseAllocationResidenceDialog}
                open={openAllocationResidenceDialog}>
                <AllocationResidence
                    reserveId={reserveId}
                    requestId={requestId}
                    periodId={periodId}
                    handleBackPage={handleCloseAllocationResidenceDialog}
                    handleCloseDialog={handleCloseAllocationResidenceDialog}
                />
            </RaikoDefaultDialogPage>
            {
                isRejected ? <>
                        <RaikoAlert
                            type={raikoAlertTypes.error}
                            title={"این درخواست توسط ادمین رد شده است !"}
                            description={["امکان ایجاد تغییرات بر روی درخواست های رد شده وجود ندارد."]}
                        />
                    </> :
                    reserveId >= 0 ?
                        <RaikoButtonPrimary
                            className={css`width: 100%`}
                            label={"ویرایش اقامتگاه"}
                            onClick={handleOpenAllocationResidenceDialog}/>
                        :
                        <>
                            <RaikoGridOneColumn className="selectedItemsDashedContainer">
                                <RaikoGridOneColumn className={css`place-items: center`}>
                                    <RaikoLabel
                                        className={`warningText`}
                                        text={"هنوز هیچ اقامتگاهی ثبت نشده است !"}/>
                                    <RaikoGridTwoColumn>
                                        <RaikoButtonSecondary label={"رد درخواست"} onClick={handleOpenConfirmDialog}/>
                                        <RaikoButtonPrimary className={css`width: fit-content`} label={"ثبت اقامتگاه"}
                                                            onClick={handleOpenAllocationResidenceDialog}/>
                                    </RaikoGridTwoColumn>

                                </RaikoGridOneColumn>
                            </RaikoGridOneColumn>
                        </>
            }
        </>
    )
}
export default AddResidence